import React, { useState } from 'react'
import Classes from './styles/style.module.css'
import { useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion'
import backend from '../../../api';
import ViewVideo from './Comp/ViewVideo';
import ContinueDashboard from './Comp/ContinueDashboard';
import { usePreventScrolling } from '../../../Hooks/usePreventScrolling';
import VideoPlayer from './Comp/VideoPlayer';

function OnBoardingSuccessPopup({ closePopup, title, description, buttonText }) {
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;
    onBoarding.color = '#3E9BFF';

    const handleBgClick = () => {
        // closePopup();
    }

    const handleCardClick = (event) => {
        event.stopPropagation();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (onBoarding?.isFirstInteraction) {
            await backend.put(`/onboarding/${companyId}`, {
                isFirstInteraction: false
            });
        }
        closePopup();
    }

    const [activeMsg, setActiveMsg] = useState(1);
    const [direction, setDirection] = useState("forward"); // Track direction

    const handleNext = () => {
        setDirection("forward");
        setActiveMsg(prev => prev + 1);
    };

    const handleBack = () => {
        setDirection("backward");
        setActiveMsg(prev => prev - 1);
    };

    const [showVideo, setShowVideo] = useState(false);

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }} // Animation when component enters
                animate={{ opacity: 1 }}   // Animation when component is open
                exit={{ opacity: 0 }}    // Animation when component exits
                transition={{ duration: 0.2 }}
                className={Classes.popup}
                onClick={handleBgClick}
            >
                <motion.div
                    initial={{ y: -7 }} // Animation when component enters
                    animate={{ y: 0 }}   // Animation when component is open
                    exit={{ y: 7 }}    // Animation when component exits
                    transition={{ duration: 0.25 }}
                    className={Classes.card}
                    onClick={(event) => { handleCardClick(event) }}
                >
                    {activeMsg > 4 &&
                        <div className={Classes.close} onClick={handleSubmit} >
                            <img src='/icons/close.png' alt='close icon' />
                        </div>
                    }
                    <div className={Classes.bgPopup} style={{ background: onBoarding?.color }} >
                        <div></div>
                        <h5 className={Classes.title} > Let’s get started! </h5>
                        <div className={Classes.curveCon} ></div>
                    </div>
                    <div>
                        {activeMsg === 1 ? (
                            <ContinueDashboard handleNext={handleNext} handleBack={handleBack} activeMsg={activeMsg} direction={direction}
                            />
                        ) : (
                            <ViewVideo handleNext={handleNext} handleBack={handleBack} activeMsg={activeMsg} direction={direction}
                                setActiveMsg={setActiveMsg} handleSubmit={handleSubmit} setShowVideo={setShowVideo} />
                        )}
                    </div>
                </motion.div>
            </motion.div>

            <AnimatePresence>
                {showVideo && (<VideoPlayer showVideo={showVideo} setShowVideo={setShowVideo} />)}
            </AnimatePresence>
        </>
    )
}

export default OnBoardingSuccessPopup
